// @ts-ignore - allow import with query string
import { lockBody } from './util.js?v=25';

if (!customElements.get('site-drawer')) {
  customElements.define(
    'site-drawer',
    class Drawer extends HTMLElement {
      CLASSES = {
        drawerOpenClass: `site-drawer-is-open`,
        drawerOpenKeyClass: `site-drawer-is-open--${this.key}`,
      };

      constructor() {
        super();

        this.initTriggers();

        this.elements.close.forEach((close) => {
          close.addEventListener('click', this.handleClose.bind(this));
        });

        document.addEventListener('keyup', this.handleKeyup.bind(this));
        document.addEventListener('click', this.handleClick.bind(this));

        document.addEventListener('openDrawer', this.handleOpen.bind(this));

        document.addEventListener('initDrawerTriggers', this.initTriggers.bind(this));
      }

      /**
       * @param {MouseEvent | CustomEvent} [event]
       */
      handleOpen(event) {
        if (event && event.detail.key != this.key) return;

        lockBody(true);
        this.setAttribute('aria-hidden', 'false');
        this.body.classList.add(this.CLASSES.drawerOpenClass);
        this.body.classList.add(this.CLASSES.drawerOpenKeyClass);
      }

      handleClose() {
        if (this.isOpen) {
          lockBody(false);
          this.setAttribute('aria-hidden', 'true');
          this.body.classList.remove(this.CLASSES.drawerOpenClass);
          this.body.classList.remove(this.CLASSES.drawerOpenKeyClass);
        }
      }

      /**
       * @param {MouseEvent} event
       */
      handleTrigger(event) {
        event.preventDefault();

        this.isOpen ? this.handleClose() : this.handleOpen();
      }

      /**
       * @param {MouseEvent} event
       */
      handleClick(event) {
        if (!event.target) return;

        if (!event.target.closest('.site-drawer') && !event.target.closest('[js-drawer-trigger]')) {
          this.handleClose();
        }
      }

      /**
       * @param {KeyboardEvent} event
       */
      handleKeyup(event) {
        switch (event.key) {
          case 'Escape':
            this.handleClose();
          default:
            break;
        }
      }

      initTriggers() {
        this.elements.triggers.forEach((trigger) => {
          if (this.hasBeenInitialized(trigger)) return;

          trigger.addEventListener('click', this.handleTrigger.bind(this));
          trigger.setAttribute('js-drawer-trigger-initialized', 'true');
        });
      }

      /**
       * @param {HTMLElement} trigger
       */
      hasBeenInitialized(trigger) {
        return trigger.hasAttribute('js-drawer-trigger-initialized');
      }

      get isOpen() {
        return this.getAttribute('aria-hidden') === 'false';
      }

      get key() {
        return this.getAttribute('key');
      }

      get elements() {
        return {
          /**
           * @type {NodeListOf<HTMLElement>}
           */
          triggers: document.querySelectorAll(`[js-drawer-trigger=${this.key}]`),
          close: this.querySelectorAll(`[js-drawer-close]`),
        };
      }

      get content() {
        return this.querySelector('.site-drawer__content');
      }

      get body() {
        return document.body;
      }
    },
  );
}
